import { Button, ButtonGroup } from 'react-bootstrap';
import styled from 'styled-components';

import BasicSpinner from './BasicSpinner';

const StyledButtonGroup = styled(ButtonGroup)`
  background-color: ${(props) => props.theme.colors.extraLight};
  border-radius: 30px !important;
  padding: 4px;
`;

const StyledToggleButton = styled(Button)`
  && {
    border-radius: 30px !important;
    margin: 0;
    padding: 6px 20px;
  }

  ${(props) =>
    props.$disableNoDim &&
    `
    &&:disabled,
    &&.disabled {
      opacity: 1 !important;
      cursor: default;
    }
  `}

  &.btn-secondary {
    border-color: ${(props) => props.theme.colors.extraLight};
    background-color: ${(props) => props.theme.colors.extraLight};
    color: ${(props) => props.theme.colors.light};

    &:hover {
      border-color: ${(props) => props.theme.colors.extraLight} !important;
      background-color: ${(props) => props.theme.colors.extraLight} !important;
      color: ${(props) => props.theme.colors.off} !important;
    }
  }

  &:first-child {
    margin-right: 1px;
  }
`;

const SpinnerWrapper = styled.div`
  position: relative;
  top: 1px;
`;

const Toggle = ({ switchOn, isLoading, isSaving, handleSwitchChange, onLabel = 'ON', offLabel = 'OFF' }) => {
  const isBusy = Boolean(isLoading) || Boolean(isSaving);
  const disableOnButton = isBusy || Boolean(switchOn);
  const disableOffButton = isBusy || !Boolean(switchOn);

  return (
    <div className="d-flex align-items-center">
      <StyledButtonGroup className="mt-2">
        <StyledToggleButton
          variant={switchOn ? 'primary' : 'secondary'}
          onClick={() => handleSwitchChange(true)}
          disabled={disableOnButton}
          $disableNoDim={!isBusy && Boolean(switchOn)}
        >
          {onLabel}
        </StyledToggleButton>
        <StyledToggleButton
          variant={!switchOn ? 'primary' : 'secondary'}
          onClick={() => handleSwitchChange(false)}
          disabled={disableOffButton}
          $disableNoDim={!isBusy && !Boolean(switchOn)}
        >
          {offLabel}
        </StyledToggleButton>
      </StyledButtonGroup>
      {(isLoading || isSaving) && (
        <SpinnerWrapper>
          <BasicSpinner />
        </SpinnerWrapper>
      )}
    </div>
  );
};

export default Toggle;
